<a-card class="mb50">
  <table-wrapper
    :row-key="'uuid'"
    ref="tableWrappers"
    :dataSource="records"
    :showCheckbox="true"
    :columns="columns"
    @onSelectionChange="onSelectionChange"
  >
    <template #buttons>
      <a-space>
        <a-button type="primary" @click="addRow">新增行</a-button>
        <a-button :disabled="selectedUuids.length === 0" @click="deleteRows">删除选中</a-button>
      </a-space>
    </template>

    <template #workPackagesId="{ record }">
      <workPackage-select
        v-model:value="record.workPackagesId"
        class="w100 append-to-table"
        placeholder="请选择工作包"
        :allowClear="false"
        @change="workPackageChange($event,record)"
      ></workPackage-select>
    </template>
    <template #isPhotograph="{ record } ">
      <img
        class="tb-img"
        v-if="record.isPhotograph==1"
        :src="isZHXH?checkRightGreen:checkRight"
        alt=""
      />
      <span v-else>-</span>
    </template>
    <template #isExplain="{ record } ">
      <img
        class="tb-img"
        v-if="record.isExplain==1"
        :src="isZHXH?checkRightGreen:checkRight"
        alt=""
      />
      <span v-else>-</span>
    </template>
    <template #operation="{ record }">
      <a-space :size="16">
        <a href="javascript:void(0)" v-if="record.sortValue!=1" @click="moveTask(record,'p')">上移</a>
        <a
          href="javascript:void(0)"
          v-if="record.sortValue!=(records.length)"
          @click="moveTask(record,'n')"
          >下移</a
        >
        <a href="javascript:void(0)" v-if="record.sortValue!=1" @click="moveTask(record,'t')">置顶</a>
        <a
          href="javascript:void(0)"
          v-if="record.sortValue!=(records.length)"
          @click="moveTask(record,'b')"
          >置底</a
        >
      </a-space>
    </template>
  </table-wrapper>
</a-card>
